<template>
	<div style="margin-top: 0px;">
		<!-- 页头 -->
		<roheader></roheader>
		<!-- 内容 -->
		<div style="width:100%;background: #F1F1F1;overflow: auto;padding-bottom: 30px;">
			<div style="width:1200px;margin:auto;padding:20px;">
				<rosidebar :selected_page='selected_page'></rosidebar>
				<!-- 微信支付提示弹出页面 -->
				<el-dialog title="微信支付" :visible.sync="wxpay_dialogVisible" width="40%" :before-close="handleClose">
					<el-tabs v-model="payName" type="card">
						<div style="overflow: hidden;width:85%;margin:20px auto;">
							<el-result icon="success" :title="order_pay_title" style="float:left;overflow: hidden;width: 50%;">
								<template slot="extra" style="color:black;font-weight: 500;">
									<div style="font-size: 20rpx;">
										<span style="float:left">支付方式：</span>
										<span style="float:right">微信收银</span>
									</div>
									<div style="font-size: 20rpx;">
										<span style="float:left">支付金额：</span>
										<span style="color: red;float:right;font-weight: 500;">¥{{total_fees}}元</span>
									</div>
								</template>
							</el-result>
							<!-- v-loading：这是一个自定义指令或组件的标识，用于触发加载状态的显示。
							="loading"：这里的loading是一个Vue实例中定义的响应式数据属性。它的值（通常是布尔类型）决定了加载状态是否应该被显示。
							当loading为true时，加载效果（如遮罩层、加载动画等）会显示在绑定的元素上；当loading为false时，加载效果会隐藏。 -->
							<div v-loading="loading" style="float:right;overflow: hidden;width: 50%;">
								<p>{{ prompt1 }}{{ countdown }}{{ prompt2 }}</p>
								<img style="height: 100px;" :src='wx_pay_img'  />
							</div>
						</div>
						<div style="width:85%;margin: auto;">
							<el-button type="primary" style="width: 200px;margin-bottom: 5%; float: right;margin-right:calc( 25% - 100px );" @click="handleClose">退出</el-button>
						</div>
					</el-tabs>
				</el-dialog>

				<!-- 支付宝支付提示弹出页面 -->
				<el-dialog title="支付宝支付" :visible.sync="alipay_dialogVisible" width="40%" :before-close="handleClose">
					<el-tabs v-model="payName" type="card">
						<div style="overflow: hidden;width:85%;margin:20px auto;">
							<el-result icon="success" :title="order_pay_title" style="float:left;overflow: hidden;width: 50%;">
								<template slot="extra" style="color:black;font-weight: 500;">
									<div style="font-size: 20rpx;">
										<span style="float:left">支付方式：</span>
										<span style="float:right">支付宝</span>
									</div>
									<div style="font-size: 20rpx;">
										<span style="float:left">支付金额：</span>
										<span style="color: red;float:right;font-weight: 500;">¥{{total_fees}}元</span>
									</div>
								</template>
							</el-result>
							<div v-loading="loading" style="float:right;overflow: hidden;width: 50%;text-align: center;">
								<p>{{ prompt1 }}{{ countdown }}{{ prompt3 }}</p>
								<iframe style="width:110px;height:110px;display: inline-block; margin-top: 10px;" :src='ali_pay_img'></iframe>
							</div>
						</div>
						<div style="width:85%;margin: auto;">
							<el-button type="primary" style="width: 200px;margin-bottom: 5%; float: right;margin-right:calc( 25% - 100px );" @click="handleClose">退出</el-button>
						</div>
					</el-tabs>
				</el-dialog>



				<div style="float: right;width:calc(100% - 269px);;background: white;">
					<div style="width: 90%;margin:20px auto;">
						<el-steps :active="activePage" finish-status="success" simple style="margin-top: 20px">
							<el-step title="填写基本信息" icon="el-icon-edit"></el-step>
							<el-step title="填写查引内容" icon="el-icon-edit"></el-step>
							<el-step title="支付" icon="el-icon-edit"></el-step>
						</el-steps>
					</div>
					<!-- 第1页填写基本信息 -->
					<div v-if="this.activePage == 0"
						style="width: 90%;margin:20px auto;background-color: #F0F0F0;padding:10px;">
						<div v-if='approval_note'
							style="background-color: #fcdede;padding:0 15px;color:black;float: left;margin-bottom: 10px;;padding: 20px;width: 100%;">
							<div>您的申请资料未通过审核，请查看原因并重新提交：</div>
							<div style="font-weight: bold;">{{approval_note}}</div>
						</div>

						<el-form :model="form_setp_1" ref="form_setp_1" :rules="form_setp_1_rules" label-width="100px" class="demo-ruleForm" style="padding:10px;">
							<div style="width:100%;border:2px dotted #cdcdcd;padding:20px;overflow: hidden;">
								<el-radio-group v-model="address_selected" style="width: 100%;"
									@change="select_address($event)">
									<el-radio border class="ro-address-radio"
										v-for="(address_data, index) in address_datas" :key="index"
										:label="address_data.name">
										<span style="width: 100%;"
											:data-id="address_data.id">{{address_data.contact}}</span>
										<div style="width: 100%;" :data-id="address_data.id" class="ro-box-content">
											{{address_data.address}}，{{address_data.contact_mobile}}
										</div>
									</el-radio>
								</el-radio-group>
								<el-row>
									<el-button @click="turn_to_new_info" style="margin-top: 20px;background: red;color:white;">新增个人信息</el-button>
								</el-row>
							</div>
							<el-form-item label="单位名称" prop="unit_name" style="margin-top: 30px;">
								<el-input v-model="form_setp_1.unit_name"></el-input>
							</el-form-item>
							<div style="overflow: hidden;">
								<el-form-item label="通讯地址" prop="address" style="float: left;width: 60%;">
									<el-cascader style="width: 100%;" size="large" :options="AreaOptions"
										v-model="selectedArea" @change="handleChangeArea">
									</el-cascader>
								</el-form-item>
								<el-form-item label="邮编" prop="postcode" style="float: right;width: 40%;">
									<el-input v-model="form_setp_1.postcode"></el-input>
								</el-form-item>

							</div>
							<div style="overflow: hidden;">
								<el-form-item label="详细地址" prop="address" style="float: left;width: 60%;">
									<el-input v-model="form_setp_1.address"></el-input>
								</el-form-item>
							</div>
							<div style="overflow: hidden;">
								<el-form-item label="委托人" prop="contact" style="float: left;width: 50%;">
									<el-input v-model="form_setp_1.contact"></el-input>
								</el-form-item>
								<el-form-item label="手机" prop="contact_mobile" style="float: left;width: 50%;">
									<el-input v-model="form_setp_1.contact_mobile"></el-input>
								</el-form-item>
							</div>
							<div style="overflow: hidden;">
								<el-form-item label="邮箱" prop="email" style="float: left;width: 50%;">
									<el-input v-model="form_setp_1.email"></el-input>
								</el-form-item>
								<el-form-item label="座机" prop="contact_phone" style="float: left;width: 50%;">
									<el-input v-model="form_setp_1.contact_phone"></el-input>
								</el-form-item>
							</div>

							<el-form-item style="margin-top: 240px;">
								<el-button type="primary" style='margin-left: -95px;' @click="create_kjcx(next=true)">保存并下一步</el-button>
								<el-button type="" @click="create_kjcx(next=false)">保存并退出</el-button>
							</el-form-item>
						</el-form>
					</div>

					<!-- 第2页填写查引内容 -->
					<div v-if="this.activePage == 1"
						style="width: 90%;margin:20px auto;padding:5% 1%;background-color: #F0F0F0;overflow: auto;">
						<div label-width="95px" class="demo-ruleForm">
							<div style="font-size: 12px;">温馨提示：带<span style="color:red;">*</span>的是必填项</div>
							<div v-if='!approval_note' style="font-size: 12px;">注：填写委托单位名称，报告作者名字或团队名称。</div>
							<div v-if='!approval_note' style="font-size: 12px;">例如：内蒙古大学张大大发表的论文收录情况
								内蒙古大学“草原综合治理”团队提供的论文收录情况</div>
							<div v-if='approval_note'
								style="background-color: #fcdede;padding:0 15px;color:black;float: left;margin-bottom: 10px;margin-top:-30px;padding: 20px;width: 100%;">
								<div>您的申请资料未通过审核，请查看原因并重新提交：</div>
								<div style="font-weight: bold;">{{approval_note}}</div>
							</div>
							<el-form  :model="form_setp_1" ref="form_setp_1" label-width="100px" class="demo-ruleForm" :rules="form_setp_1_rules">
								<el-form-item label="项目名称"  prop='name'>
									<el-input v-model="form_setp_1.name"></el-input>
								</el-form-item>
							</el-form>
							<el-collapse v-model="activeNames">
								<el-collapse-item title="一、查引范围" name="1">
									<div v-for="(data, index) in inputData" :key="index" style='width: 100%; border: 2px dotted rgb(205, 205, 205); padding: 20px; overflow: hidden;margin-top: 20px;'>
										<div style="float: left;font-size: 28px;background-color: #f8f9fa;border-radius: 50%;width: 50px;">{{index+1}}</div>
										<el-form :model="data" :rules="kjcy_data_rules" ref="kjcy_data_form" :key="index" label-width="130px" class="demo-ruleForm">
											<el-form-item label="查引范围:" prop="scope" v-if='pay_date==""'>
												<el-radio v-model="data.scope" label="home">国内</el-radio>
												<el-radio v-model="data.scope" label="abroad">国外</el-radio>
											</el-form-item>
											<el-form-item label="查引范围:" prop="scope" v-if='pay_date!=""'>
												<el-radio v-model="data.scope" label="home" disabled>国内</el-radio>
												<el-radio v-model="data.scope" label="abroad" disabled>国外</el-radio>
											</el-form-item>
											<el-form-item label="题目:" prop="title">
												<el-input type="textarea" :autosize="{ minRows: 5}" v-model="data.title" placeholder="题目" />
											</el-form-item>
											<el-form-item label="作者:" prop="author">
												<el-input type="textarea" :autosize="{ minRows: 5}" v-model="data.author" placeholder="作者" />
											</el-form-item>
											<el-form-item label="来源出版物:" prop="source">
												<el-input type="textarea" :autosize="{ minRows: 5}" v-model="data.source" placeholder="来源出版物" />
											</el-form-item>
											<el-button style="float: right;" type="danger" @click="removeInput(index)" v-if='pay_date==""' >删除</el-button>
										</el-form>
									</div>
									<el-button style="float: left;margin-top: 20px;" type="success" v-if='pay_date==""' @click="addInput">新增查引内容</el-button>
								</el-collapse-item>
							</el-collapse>
							<div style="margin-top: 20px" ref='bottom'>
								<el-button type="primary" style='margin-left: -95px;' v-if='edit_mode &&pay_date!=""'
									@click="update_kjcx(turn_to_order_list=true,back_to_previous_page=false,confirm=true)">确认修改 <!--编辑已支付的订单， 直接跳转到订单列表了-->
								</el-button>
								<el-button type="primary" v-if='pay_date==""'
									@click="update_kjcx(turn_to_order_list=false,back_to_previous_page=false,confirm=false)">保存并下一页 <!--编辑未支付的订单， 还需下一页-->
								</el-button>
								<el-button type="" @click="update_kjcx(turn_to_order_list=false,back_to_previous_page=true,confirm=false)">保存并上一页
								</el-button>
								<el-button type="" @click="update_kjcx(turn_to_order_list=true,back_to_previous_page=false,confirm=false)">保存并退出
								</el-button>
							</div>
						</div>
					</div>
					<!-- 第3页支付 -->
					<div v-if="this.activePage == 2"
						style="width: 90%;margin:20px auto;padding:5% 1%;background-color: #F0F0F0;overflow: auto;">
						<el-form label-width="100px" class="demo-ruleForm">
							<div style="width:100%;text-align: left;">
								<el-form-item label="项目名称">
									<el-input v-model="form_setp_1.name" disabled></el-input>
								</el-form-item>							
								<el-collapse v-model="activeNames">
									<el-collapse-item title="一、报告提交日期" name="1">
										<div
											style="background-color: #fcdede;padding:0 15px;color:black;;padding: 20px;">
											<div>温馨提示，一般情况下，提交申请并完成支付后3-5个工作日出具报告，特殊情况另行通知。</div>
										</div>

										<el-form-item label="预计出报告日期" style="margin-top: 30px;white-space: nowrap">
											<div
												style="margin-left: 10px; width: 10%;float: left;text-align: center;color:black;background-color: white;line-height: 32px;">
												{{expected_report_time[0]}}
											</div>
											<div style="width: 5%;float: left;text-align: center;color:black;line-height: 32px;">
												至
											</div>
											<div
												style="width: 10%;float: left;text-align: center;color:black;background-color: white;line-height: 32px;">
												{{expected_report_time[1]}}
											</div>
										</el-form-item>
									</el-collapse-item>
									<el-collapse-item title="二、报告相关费用" name="2">
										<div
											style="background-color: #fcdede;padding:0 15px;color:black;;padding: 20px;">
											<div>温馨提示：仅支持线上自取报告！</div>
											<div>国内查引收费标准：少于5篇/50元，5-10篇100元，11-15篇150元，16-20篇200元，20篇以上每篇10元</div>
											<div>国外查引收费标准：少于5篇/100元，5-10篇200元，11-15篇300元，16-20篇400元，20篇以上每篇20元</div>
											<div>如果同一个项目中既有国内查引、又有国外查引，国内外查引篇数分别统计</div>
										</div>
										<div style="margin-top: 60px;color:black">
											<h5 style="width: 33%;float: left;text-align: center;color:black">
												国内查引{{home_qty}}篇，费用:<span style="color:orange">{{home_fees}}元</span>
											</h5>
											<h5 style="width: 33%;float: left;text-align: center;color:black">
												国外查引{{abroad_qty}}篇，费用:<span
													style="color: dodgerblue;">{{abroad_fees}}元</span>
											</h5>
											<h5 style="width: 33%;float: left;text-align: center;color:black">
												总费用：<span style="color:red">{{total_fees}}元</span>
											</h5>
										</div>
									</el-collapse-item>
								</el-collapse>
							</div>
							<div style="background-color: #fcdede;padding:0 15px;color:black;;padding: 20px;">
								<div>注意：支付成功的订单才能进入审核状态！请选择支付方式并支付：</div>
							</div>
							<el-form-item style="margin-top: 20px;">
								<img src="../assets/wx_pay.jpg" style="cursor: pointer;margin-left: -100px;margin-right: 30px;width: 320px; height: 160px;" @click="processPayment('wxpay', turn_to_order_list=false,back_to_previous_page=false)" alt="微信支付">
								<!-- <img src="../assets/ali_pay.jpg" style="cursor: pointer;width: 320px; height: 160px;" @click="processPayment('alipay', turn_to_order_list=false,back_to_previous_page=false)" alt="支付宝支付"> -->
							</el-form-item>

							<el-form-item style="margin-top: 20px;">								
								<el-button @click="finish_kjcx(turn_to_order_list=false,back_to_previous_page=true)">保存并上一步</el-button>
								<el-button @click="finish_kjcx(turn_to_order_list=true,back_to_previous_page=false)">保存并退出</el-button>
							</el-form-item>
						</el-form>
					</div>
				</div>

			</div>
		</div>
		<!-- 页脚 -->
		<rofooter></rofooter>
	</div>
</template>

<script>
	import {
		fetchGet,
		fetchPost
	} from "../utils/request"
	import qs from 'qs'
	import {
		baseURL
	} from "../utils/baseURL"
	// 1.导入组件
	import roheader from "./components/ro_header.vue";
	import rofooter from "./components/ro_footer.vue";
	import rosidebar from "./components/ro_sidebar.vue";
	import {
		provinceAndCityData,
		regionData,
		provinceAndCityDataPlus,
		regionDataPlus,
		CodeToText,
		TextToCode
	} from 'element-china-area-data'
	export default {
		name: 'user_kjcy',
		data() {
			return {
				wx_pay_img: 'https://p2.itc.cn/images01/20211001/f2b77a3dd20f4be88cd84a9d659fa1cb.jpeg',
				wxpay_dialogVisible: false,
				alipay_dialogVisible: false,
				pay_date: '', //判断是否支付过
				countdown: 60, // 倒计时初始值
				countdownTimer: null, // 用于保存倒计时定时器的引用
				payment_status: null, // 用于保存支付状态 null:未支付  success:支付成功
				prompt1: '请在',
				prompt2: '秒内微信扫描二维码支付',
				prompt3: '秒内支付宝扫描二维码支付',
				AreaOptions: regionData,
				province: '',
				area: '',
				city: '',
				selectedArea: [],
				payName: '微信支付',
				get_pay_state_timer: null,
				ali_pay_img:'',				
				order_pay_title: '订单创建成功',
				form_setp_1: {
					'name': '',
					'unit_name': '',
					'address': '',
					'postcode': '',
					'contact': '',
					'contact_mobile': '',
					'contact_phone': '',
					'email': ''
				},
				form_setp_1_rules: {
					name: [{
						required: true,
						message: '项目名称不能为空',
						trigger: 'blur'
					}],
					unit_name: [{
						required: true,
						message: '单位名称不能为空',
						trigger: 'blur'
					}],
					address: [{
						required: true,
						message: '地址不能为空',
						trigger: 'blur'
					}],
					contact: [{
						required: true,
						message: '联系人不能为空',
						trigger: 'blur'
					}],
					contact_mobile: [{
						required: true,
						message: '手机不能为空',
						trigger: 'blur'
					}],
					contact_phone: [{
						required: false
					}],
				},
				selected_page: '2-2',
				inputData: [{
					scope: 'home',
					title: '',
					author: '',
					source: ''
				}],
				kjcy_data_rules: {
					scope: [
					  { required: false, message: '', trigger: 'blur' }
					],
					title: [
					  { required: true, message: '题目不能为空', trigger: 'blur' }
					],
					author: [
					  { required: true, message: '作者不能为空', trigger: 'blur' }
					],
					source: [
					  { required: true, message: '来源出版物不能为空', trigger: 'blur' }
					]
				},
				activePage: 0,
				textarea_max_length: 200,

				address_selected: '',

				activeNames: ['1', '2', '3', '4'],
				address_datas: [],
				select_date: '',
				references: [],
				order_id: 0,
				attachment_name: '',
				attachment_url: '',
				dialogVisible: false,
				loading: true,
				paying: false,
				pay_img: 'https://p2.itc.cn/images01/20211001/f2b77a3dd20f4be88cd84a9d659fa1cb.jpeg',
				fees_datas: [],
				fees_select: '',
				basic_fees: 0,
				total_fees: 0,
				urgent_fees: 0,
				abroad_fees: 0,
				home_fees: 0,
				abroad_qty: 0,
				home_qty: 0,
				expected_report_time: [0, 0],
				pay_date: '',
				edit_mode: false, //判定是否是 从编辑订单过来的
				state: 'edit', //默认就是编辑中draft，如果 审核没通过，那就是 eidt，此时还要显示未通过原因。
				approval_note: '', //默认就是编辑中draft，如果 审核没通过，那就是 eidt，此时还要显示未通过原因。
			}
		},
		mounted() {
			var self = this
			var self = this
			var id = this.$route.query.id
			// debugger
			if (id != undefined) {
				this.order_id = id
				this.edit_mode = true
				// debugger
				var data = {
					'id': id,
				}
				var self = this
				fetchPost('/ro/tec_search/order/detail/v1', data).then(response => {
					console.log('=------data------')
					console.log(response.data.data)
					var order_data = response.data.data

					self.id = order_data.id
					self.approval_note = order_data.approval_note
					self.state = order_data.state
					self.form_setp_1.name = order_data.name
					self.form_setp_1.unit_name = order_data.unit_name
					self.form_setp_1.address = order_data.address
					self.form_setp_1.email = order_data.email
					self.form_setp_1.postcode = order_data.postcode
					self.form_setp_1.contact = order_data.contact
					self.form_setp_1.contact_phone = order_data.contact_phone
					self.form_setp_1.contact_mobile = order_data.contact_mobile

					self.attachment_name = order_data.attachment_name
					self.attachment_url = order_data.attachment_url

					self.inputData = JSON.parse(order_data.reference_ids)
					self.type = 'references'
                    self.pay_date = order_data.pay_date
					var province = TextToCode[order_data.province].code
					var city = TextToCode[order_data.province][order_data.city].code
					var area = TextToCode[order_data.province][order_data.city][order_data.area].code
					self.province = order_data.province
					self.city = order_data.city
					self.area = order_data.area
					self.address_selected = order_data.info_id
					self.selectedArea = [province, city, area]
				})
			}
			this.get_address_data()
		},
		components: {
			// 2.注册局部组件
			roheader,
			rofooter,
			rosidebar,
		},
		methods: {
			validateForm() {
			  return new Promise((resolve, reject) => {
				const validationPromises = [];
				this.$refs.kjcy_data_form.forEach((form) => {
				  console.log('576 行：' + form)
				  validationPromises.push(new Promise((res, rej) => {
				  form.validate((valid) => {
					if (valid) {
					  console.log('579 行验证成功')
					  res(true);
					} else {
					  console.log('582 行验证失败')
					  rej('表单验证失败');
					}
				  });
				  }));
				});

				Promise.all(validationPromises).then(() => {
				  resolve('All forms are valid');
				})
				.catch((error) => {
				  reject(error);
				});
			  });
			},			
			handleChangeArea(value) {
				this.province = CodeToText[value[0]]
				this.city = CodeToText[value[1]]
				this.area = CodeToText[value[2]]
				console.log(this.province)
				console.log(this.city)
				console.log(this.area)
			},
			delete_file() {
				console.log('delete_file')
				var data = {
					'id': this.order_id,
				}
				var self = this
				fetchPost('/ro/tec_search/order/delete/file/v1', data).then(response => {
					self.attachment_name = ''
					self.attachment_url = ''
				})
			},
			get_file() {
				console.log(this.attachment_url)
				window.open(this.attachment_url, "_blank")
			},
			removeInput(index) {
				this.inputData.splice(index, 1)
			},
			addInput() {
				this.inputData.push({
					scope: 'home',
					title: '',
					author: '',
					source: ''
				})
				this.scrollToBottom()

			},
			submit() {
				this.inputData.forEach(data => {
					// 处理每个输入框的数据
					console.log(data.scope, data.title, data.author, data.source)
				})
			},

			turn_to_new_info() {
				this.$router.push('/user/new_infor')
			},

			get_fees_data() {
				var data = {
					'id': this.order_id,
					'type': 'reference'
				}
				var self = this
				fetchPost('/ro/tec_search/order/get_fees/v1', data).then(response => {
					console.log(response.data)
					self.fees_datas = response.data[0]
					self.total_fees = parseFloat(response.data[0].total_fees).toFixed(2)
					self.abroad_fees = parseFloat(response.data[0].abroad_fees).toFixed(2)
					self.home_fees = parseFloat(response.data[0].home_fees).toFixed(2)
					self.abroad_qty = response.data[0].abroad_qty
					self.home_qty = response.data[0].home_qty
					// debugger
					self.expected_report_time = response.data[0].expected_report_time

				})
			},
			turn_to_order_info() {
				this.$router.push('/user/order')
			},
			stop_pay_state_timer() {
			  if (this.get_pay_state_timer) {
				console.log("删除get_pay_state_timer定时器！");
				clearInterval(this.get_pay_state_timer);
				this.get_pay_state_timer = null;  // 手动将 self.get_pay_state_timer 设置为 null
			  }
			},
			stop_countdownTimer() {
			  // 清除倒计时定时器
			  if (this.countdownTimer) {
			  	console.log("删除countdownTimer倒计时定时器！");
			  	clearInterval(this.countdownTimer);
				this.countdownTimer = null;
			  }
			},
			handleClose() {
				this.stop_pay_state_timer()
				this.stop_countdownTimer()
				this.wxpay_dialogVisible = false
				this.alipay_dialogVisible = false
				this.countdown = 60
				if(this.payment_status == "success")
				{
					this.turn_to_invoice();
					this.payment_status = null;
					this.prompt1 = '请在';
					this.prompt2 = '秒内微信扫描二维码支付';
					this.prompt3 = '秒内支付宝扫描二维码支付';
				}
			},
			turn_to_invoice_new() {
				this.$router.push('/user/invoice_new')
			},
			turn_to_invoice() {
				window.location.href='#/user/invoice?id='+this.order_id+'&total_fees='+this.total_fees
				// this.$router.push('/user/invoice?id='+this.order_id+'&total_fees='+this.total_fees)
			},
			get_pay_state() {
				var self = this
				var data = {
					'id': this.order_id
				}				
				fetchPost('/ro/tec_search/order/get_payment_state/v1', data).then(response => {
					console.log(response.data)
					if (response.data.result == 'success') {
						self.order_pay_title = '订单支付完成,5s后将自动跳转'
						this.stop_pay_state_timer()						
						//等待10秒弹出开发票页面
						setTimeout(function() {
							self.turn_to_invoice()
						}, 10000)
						this.payment_status = "success";
						this.countdown = 5;
						this.prompt1 = '本页面将在';
						this.prompt2 = '秒后自动退出！';
						this.prompt3 = '秒后自动退出！';
						this.wx_pay_img = require('../assets/payment_success.png');
						this.ali_pay_img = '/alipay_success_image.html'						
					}
				})
			},
			ali_pay(){
				// debugger
				this.ali_pay_img = baseURL + '/ro/connector/alipay/ali_pay/v1?order_id=' + this.order_id+'&date='+Date.now();
				console.log('user_kjcy 657行，this.ali_pay_img = ' + this.ali_pay_img)
				setTimeout(() => {  
				        // 这里是等待3秒后执行的代码  
				        console.log('已经等待了3秒');  
				        // 你可以在这里调用其他方法或执行其他操作  
						this.loading = false
						console.log('user_kjcy 663行，this.loading = ' + this.loading)
						console.log('user_kjcy 664行，this.ali_pay_img = ' + this.ali_pay_img)
				}, 3000); // 3000毫秒 = 3秒  				
				console.log('user_kjcy 667行，this.loading = ' + this.loading)
				this.paying = true
				
				if (!this.get_pay_state_timer) {
					console.log('新建 get_pay_state_timer')					
					this.get_pay_state_timer = setInterval(() => {
						console.log('循环查询订单支付情况')
						this.get_pay_state()
					}, 1000)
				}
			},
			wx_pay() {
				// debugger
				var data = {
					'order_id': this.order_id,
				}						
				fetchPost('/ro/connector/wx/wx_pay_native/v1', data).then(response => {
					console.log(response.data)
					this.wx_pay_img = response.data //获得的微信支付二维码
					this.loading = false
					this.paying = true
					
					if (this.get_pay_state_timer == null) {
						console.log('新建 get_pay_state_timer')						
						this.get_pay_state_timer = setInterval(() => {
							console.log('循环查询订单支付情况')
							this.get_pay_state()
						}, 1000)
						// debugger						
					}
				})				
			},
			handleResponse(response, turn_to_order_list, back_to_previous_page) {
				if (response.data.result === 'session_expired') {
					window.location.href = '/#/pages/login';
					return;
				}
				if (!turn_to_order_list) {
					if (back_to_previous_page) {
						this.activePage -= 1;
					}
				} else {
					this.$router.push(this.pay_date === '' ? "/user/order?type=未提交" : "/user/order");
				}
				this.scrollToTop();
			},
			startCountdown() {
				this.countdownTimer = setInterval(() => {
					if (this.countdown > 0) {
						this.countdown--;
						console.log(this.countdown);
					} else {
						this.handleClose(); // 倒计时结束时调用 handleClose
					}
				}, 1000);
			},

			processPayment(type,turn_to_order_list, back_to_previous_page, extraData = {}) {
				var data = {
					'id': this.order_id,
					'info_id': this.address_selected,
					'province': this.province,
					'city': this.city,
					'area': this.area,

					'references': JSON.stringify(this.references),
					'name': this.form_setp_1.name,
					'en_name': this.form_setp_1.en_name,
					'unit_name': this.form_setp_1.unit_name,
					'address': this.form_setp_1.address,
					'email': this.form_setp_1.email,
					'postcode': this.form_setp_1.postcode,
					'contact': this.form_setp_1.contact,
					'contact_phone': this.form_setp_1.contact_phone,
					'contact_mobile': this.form_setp_1.contact_mobile,
					'user_id': window.localStorage.getItem('user_id'),
					'type': 'reference',
					'total_fees': this.total_fees,
					'urgent_fees': this.urgent_fees,
					'basic_fees': this.basic_fees,
					'confirm':false,
					'finish':true
				}
				fetchPost('/ro/tec_search/order/update/v1', data).then(response => {
					this.handleResponse(response, turn_to_order_list, back_to_previous_page);
				// debugger
					if (!turn_to_order_list && !back_to_previous_page) {
						if (type === 'wxpay') {
							this.wxpay_dialogVisible = true;
							this.wx_pay();
						} else if (type === 'alipay') {
							this.alipay_dialogVisible = true;
							this.ali_pay();
						}
						this.loading = true;
						this.startCountdown();
					}
				});
			},

			finish_kjcx(turn_to_order_list, back_to_previous_page) {
				var self = this
				var data = {
					'id': this.order_id,
					'info_id': this.address_selected,
					'province': this.province,
					'city': this.city,
					'area': this.area,

					'references': JSON.stringify(this.references),
					'name': this.form_setp_1.name,
					'en_name': this.form_setp_1.en_name,
					'unit_name': this.form_setp_1.unit_name,
					'address': this.form_setp_1.address,
					'email': this.form_setp_1.email,
					'postcode': this.form_setp_1.postcode,
					'contact': this.form_setp_1.contact,
					'contact_phone': this.form_setp_1.contact_phone,
					'contact_mobile': this.form_setp_1.contact_mobile,
					'user_id': window.localStorage.getItem('user_id'),
					'type': 'reference',
					'total_fees': this.total_fees,
					'urgent_fees': this.urgent_fees,
					'basic_fees': this.basic_fees,
					'confirm':false,
					'finish':true
				}
				this.validateForm().then((message) => {
				  console.log(message);
				  // 表单验证成功后的逻辑
				  fetchPost('/ro/tec_search/order/update/v1', data).then(response => {
				  	if(response.data.result=='session_expired'){
						window.location.href='/#/pages/login'
					}
				  	if (!turn_to_order_list) {
				  		if (back_to_previous_page) {
				  			self.activePage -= 1
				  		} 
				  		self.scrollToTop()
				  	} else {
				  		self.scrollToTop()
				  		if (self.pay_date == '') {
				  			self.$router.push("/user/order?type=未提交")
				  		} else {
				  			self.$router.push("/user/order")
				  		}
				  	}
				  })
				})
				.catch((error) => {
				  console.log(error);
				  // 表单验证失败后的逻辑
				});
			},
			update_kjcx(turn_to_order_list, back_to_previous_page,confirm) {
				var self = this
				var data = {
					'id': this.order_id,
					'info_id': this.address_selected,
					'province': this.province,
					'city': this.city,
					'area': this.area,
					'references': JSON.stringify(this.inputData),
					'name': this.form_setp_1.name,
					'en_name': this.form_setp_1.en_name,
					'unit_name': this.form_setp_1.unit_name,
					'address': this.form_setp_1.address,
					'email': this.form_setp_1.email,
					'postcode': this.form_setp_1.postcode,
					'contact': this.form_setp_1.contact,
					'contact_phone': this.form_setp_1.contact_phone,
					'contact_mobile': this.form_setp_1.contact_mobile,
					'user_id': window.localStorage.getItem('user_id'),
					'type': 'reference',
					'confirm':confirm,
				}				
				if(this.form_setp_1.name==''){
					this.$message.error('请填写项目名称')
					return
				}
				data['edit_mode'] = 'no'
				this.validateForm().then((message) => {
				  console.log('804 行：'+message);
				  // 表单验证成功后的逻辑
					fetchPost('/ro/tec_search/order/update/v1', data).then(response => {
						if(response.data.result=='session_expired'){
												window.location.href='/#/pages/login'
											}
						self.get_fees_data()
						if (self.edit_mode && self.pay_date != '') {
							if (!turn_to_order_list) {
								if (back_to_previous_page) {
									self.activePage -= 1
								} else {
									self.activePage += 1
								}
								self.scrollToTop()
							} else {
								self.scrollToTop()
								if (self.pay_date == '') {
									self.$router.push("/user/order?type=未提交")
								} else {
									self.$router.push("/user/order")
								}
							}
						} else {
							if (!turn_to_order_list) {
								if (back_to_previous_page) {
									self.activePage -= 1
								} else {
									self.activePage += 1
								}
								self.scrollToTop()
							} else {
								self.scrollToTop()
								if (self.pay_date == '') {
									self.$router.push("/user/order?type=未提交")
								} else {
									self.$router.push("/user/order")
								}
							}
						}
					})
				})
				.catch((error) => {
				  console.error(error);
				  // 表单验证失败后的逻辑
				});
			},
			handleUploadForm(param) {
				var self = this
				// debugger;
				const reader = new FileReader()
				const file_name = param.file.name
				reader.readAsDataURL(param.file) // 把目标文件转地址，文件来自于上传组件。
				reader.onload = function() { // 文件读取成功时触发
					// debugger;					
					var data = {
						'id': self.order_id,
						'file_name': file_name,
					}
					data.file = reader.result
					console.log(data)
					fetchPost('/ro/tec_search/order/file/update/v1', data).then(response => {

					})
				}
			},
			create_kjcx(next = false) {
				var self = this
				if (this.order_id == 0) {
					var data = {
						'references': JSON.stringify(this.inputData),
						'name': this.form_setp_1.name,
						'en_name': this.form_setp_1.en_name,
						'unit_name': this.form_setp_1.unit_name,
						'address': this.form_setp_1.address,
						'email': this.form_setp_1.email,
						'postcode': this.form_setp_1.postcode,
						'contact': this.form_setp_1.contact,
						'contact_phone': this.form_setp_1.contact_phone,
						'contact_mobile': this.form_setp_1.contact_mobile,
						'info_id': this.address_selected,
						'province': this.province,
						'city': this.city,
						'area': this.area,
						'user_id': window.localStorage.getItem('user_id'),
						'type': 'reference'

					}

					console.log(data)
					this.$refs.form_setp_1.validate(valid => {
						if (valid) {
							fetchPost('/ro/tec_search/order/create/v1', data).then(response => {
								if(response.data.result=='session_expired'){
														window.location.href='/#/pages/login'
													}
								self.order_id = response.data.id
								if (next) {
									self.activePage += 1
									self.scrollToTop()
								} else {
									self.scrollToTop()
									if (self.pay_date == '') {
										self.$router.push("/user/order?type=未提交")
									} else {
										self.$router.push("/user/order")
									}
								}
							})
						} else {
							self.$message.error('请完善必填字段')
						}
					})
				} else {
					var data = {
						'id': this.order_id,
						'info_id': this.address_selected,
						'province': this.province,
						'city': this.city,
						'area': this.area,

						'references': JSON.stringify(this.inputData),
						'name': this.form_setp_1.name,
						'en_name': this.form_setp_1.en_name,
						'unit_name': this.form_setp_1.unit_name,
						'address': this.form_setp_1.address,
						'email': this.form_setp_1.email,
						'postcode': this.form_setp_1.postcode,
						'contact': this.form_setp_1.contact,
						'contact_phone': this.form_setp_1.contact_phone,
						'contact_mobile': this.form_setp_1.contact_mobile,
						'user_id': window.localStorage.getItem('user_id'),
						'type': 'reference',
						'confirm':false,
					}
					data['edit_mode'] = 'yes'
					fetchPost('/ro/tec_search/order/update/v1', data).then(response => {
						if(response.data.result=='session_expired'){
												window.location.href='/#/pages/login'
											}
						self.get_fees_data()
						if (next) {
							self.activePage += 1
							self.scrollToTop()
						} else {
							self.scrollToTop()
							if (self.pay_date == '') {
								self.$router.push("/user/order?type=未提交")
							} else {
								self.$router.push("/user/order")
							}
						}
					})
				}
			},
			select_account(e) {
				var id = e
				var select_account_data = this.account_datas.filter(item => item.id == id)[0]
				console.log(select_account_data)
				this.account_unit_name = select_account_data.unit_name
				this.account_tax_number = select_account_data.tax_number
			},
			select_fees(e) {
				// debugger
				var select_fees = this.fees_datas.filter(item => item.name == e)[0]
				this.basic_fees = parseFloat(select_fees.basic_fees).toFixed(2)
				this.urgent_fees = parseFloat(select_fees.urgent_fees).toFixed(2)
				this.total_fees = parseFloat( select_fees.total_fees).toFixed(2)
			},
			select_address(e) {
				// debugger
				var id = e
				var select_address_data = this.address_datas.filter(item => item.id == id)[0]
				this.form_setp_1.unit_name = select_address_data.unit_name
				this.form_setp_1.postcode = select_address_data.postcode
				this.form_setp_1.address = select_address_data.address
				this.form_setp_1.email = select_address_data.email
				this.form_setp_1.contact = select_address_data.contact
				this.form_setp_1.contact_phone = select_address_data.contact_phone
				this.form_setp_1.contact_mobile = select_address_data.contact_mobile
				var province = TextToCode[select_address_data.province].code
				var city = TextToCode[select_address_data.province][select_address_data.city].code
				var area = TextToCode[select_address_data.province][select_address_data.city][select_address_data.area]
					.code
				this.province = select_address_data.province
				this.city = select_address_data.city
				this.area = select_address_data.area
				this.selectedArea = [province, city, area]
			},
			set_default_address() {
				var self = this
				var select_address_data = self.address_datas.filter(item => item.default == true)[0]
				self.form_setp_1.unit_name = select_address_data.unit_name
				self.form_setp_1.postcode = select_address_data.postcode
				self.form_setp_1.address = select_address_data.address
				self.form_setp_1.email = select_address_data.email
				self.form_setp_1.contact = select_address_data.contact
				self.form_setp_1.contact_phone = select_address_data.contact_phone
				self.form_setp_1.contact_mobile = select_address_data.contact_mobile
				self.address_selected = select_address_data.id
				self.province = select_address_data.province
				self.city = select_address_data.city
				self.area = select_address_data.area

				var province = TextToCode[select_address_data.province].code
				var city = TextToCode[select_address_data.province][select_address_data.city].code
				var area = TextToCode[select_address_data.province][select_address_data.city][select_address_data.area]
					.code
				self.selectedArea = [province, city, area]
			},
			get_address_data() {
				// debugger
				var data = {
					id: window.localStorage.getItem('user_id')
				}
				var self = this
				fetchPost('/ro/tec_search/user/info/list/v1', data).then(response => {
					// console.log(response)
					// debugger
if(response.data.result=='session_expired'){
						window.location.href='/#/pages/login'
					}
					self.address_datas = response.data.list
					console.log(self.order_id)
					if (self.order_id == 0) {
						self.set_default_address()
					}

				})
			},
			get_account_data() {
				// debugger
				var data = {
					id: window.localStorage.getItem('user_id')
				}
				var self = this
				fetchPost('/ro/tec_search/invoice/list/v1', data).then(response => {
					console.log(response)
					self.account_datas = response.data.list
				})
			},

			scrollToTop() {
				window.scrollTo({
					top: 0,
					behavior: 'smooth'
				})
			},
			scrollToBottom() {
				const bottomEl = this.$refs.bottom
				// 滚动到最底部
				bottomEl.scrollIntoView({
					behavior: 'smooth'
				})
			},


			before() {
				if (this.active-- < 1) this.activePage = 0;
				console.log(this.activePage)
				this.scrollToTop()
			},

			// 上传文件
			handleRemove(file, fileList) {
				console.log(file, fileList);
			},
			handlePreview(file) {
				console.log(file);
			},
			handleExceed(files, fileList) {
				this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
			},
			beforeRemove(file, fileList) {
				return this.$confirm(`确定移除 ${ file.name }？`);
			},
			// 新增文献
			removeDomain(item) {
				var index = this.references.indexOf(item)
				if (index !== -1) {
					this.references.splice(index, 1)
				}
			},
			addDomain() {
				this.references.push({
					key: Date.now()
				});
			},

			tabClick(row, column, cell, event) {
				switch (column.label) {
					case '顺序':
						this.tabClickIndex = row.index
						this.tabClickLabel = column.label
						break
					default:
						return
				}
				console.log('tabClick', this.tabClickIndex, row.adName, row.adSort)
			},
			tableRowClassName({
				row,
				rowIndex
			}) {
				// 把每一行的索引放进row
				row.index = rowIndex
			},
			check_data() {
				var self = this;
				// 产品数据
				// var product_ids = this.product_ids
				// 客户
				var customer_id = this.customer_id
				// 查询数据
				// debugger;
				var postdata = {
					// 'product_ids': product_ids.join(','),
					'customer_id': customer_id,
				}
				// debugger;
				fetchPost('/ro/report_data_center/cost/datas/check', postdata, ).then(function(data) {
					self.tableData = data.data['product_data']
				})
			},
			beforeDestroy() {
			    this.stop_pay_state_timer();  // 确保在组件销毁时清除定时器
				// 清除倒计时定时器
				if (this.countdownTimer) {
					clearInterval(this.countdownTimer);
					this.countdownTimer = null;
				}
				if (this.get_pay_state_timer) {
					clearInterval(this.get_pay_state_timer);
					this.get_pay_state_timer = null; // 可选，清除引用
				}
			}
		}
	}
</script>
<style>
	@import url("../static/css/css2.css");
	@import url("../static/css/app.min.css");
	@import url("../static/css/fontawesome.min.css");
	@import url("../static/css/animate.min.css");
	@import url("../static/css/style.css");

	#app {
		margin-top: 0px !important;
	}

	.el-step__main {
		text-align: center;
	}

	.ro-address-radio {
		width: 31%;
		white-space: normal;
		height: 100px !important;
		float: left;
		text-align: left;
		border: 2px solid #cdcdcd !important;
		margin-left: 1% !important;
		margin-right: 1% !important;
	}

	.el-form-item__label {
		color: #333333;
		font-weight: 500;
	}

	.ro-box-content {
		border-top: 2px solid #cdcdcd;
		margin-top: 8px;
		padding-top: 8px;
		line-height: 20px;
	}

	.el-step.is-simple .el-step__icon {
		margin-top: 10px;
	}

	.el-collapse-item__header {
		background-color: #cdcdcd;
		border-radius: 3px;
		height: 35px;
		padding: 0 10px;
		font-weight: 800;
	}

	.el-collapse-item__wrap {
		background-color: #F0F0F0;
		padding: 10px;
		font-weight: 800;
		padding-bottom: 0px !important;
	}

	.el-result {
		padding-top: 0px;
		padding-bottom: 0px;
	}
	
	.custom-label-style .el-form-item__label {
	  display: flex;
	  align-items: center;
	  line-height: 1.5; /* 调整行间距，可以根据需要设置合适的值 */
	}
</style>